import styled from 'styled-components';

const FooterWrapper = styled.div`
  .ant-menu-horizontal {
    text-align: center;
  }
  .ant-menu-item, .ant-menu-item  a {
    color: white;
  }
`;

export default FooterWrapper;
